<div class="slideout-content">
    <!-- Modal to add new starts-->
    <div class="modalsd modal-slide-in sdfade new-modal" id="modals-slide-in">
        <div class="modal-dialog">
            <form class="add-new modal-content pt-0" [formGroup]="newForm" (ngSubmit)="onSubmit()">
                <button type="button" class="close" data-dismiss="modal" value="categoryEditData.category_name" aria-label="Close" (click)="toggleSidebar('new-sidebar')">
                  ×
                </button>
                <div class="modal-header mb-1">
                    <h5 class="modal-title" id="exampleModalLabel" *ngIf="categoryId == 0">New Category</h5>
                    <h5 class="modal-title" id="exampleModalLabel" *ngIf="categoryId != 0">Edit Category</h5>
                </div>
                <div class="modal-body flex-grow-1">
                    <div class="form-group">
                        <label for="register-categoryName" class="form-label">Category Name<span class="text-danger">*</span> </label>
                        <input type="text" formControlName="categoryName" class="form-control" placeholder="Category Name" aria-describedby="register-categoryName" tabindex="1" [ngClass]="{ 'is-invalid': submitted && f.categoryName.errors }" />
                        <div *ngIf="submitted && f.categoryName.errors" class="invalid-feedback">
                            <div *ngIf="f.categoryName.errors.required">Category Name is required</div>
                        </div>
                    </div>
                    <ngb-alert [type]="'danger'" [dismissible]="false" *ngIf="error">
                        <div class="alert-body">
                            <p>{{ error }}</p>
                        </div>
                    </ngb-alert>
                    <button type="submit" *ngIf="categoryId == 0" class="btn btn-primary mr-1" rippleEffect [disabled]="loading"> <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>Save</button>
                    <button type="submit" *ngIf="categoryId != 0" class="btn btn-primary mr-1" rippleEffect [disabled]="loading"> <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>Update</button>

                    <button type="reset" class="btn btn-secondary" (click)="toggleSidebar('new-sidebar')" [disabled]="loading" rippleEffect>
                        <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                        <i data-feather="x" class="d-sm-none d-inline-block mr-0 mr-sm-1"></i>
                        <span class="d-none d-sm-inline-block">Cancel </span>
                        
                  </button>

                </div>
            </form>
        </div>
    </div>
    <!-- Modal to add new Ends-->
</div>